/** @jsx jsx */
import React, {useState} from 'react';
import { css, jsx } from '@emotion/core'

export default function FilterBar(props) {
    let {onClick, selectedFilter} = props
    if (selectedFilter === undefined) {
        selectedFilter = { name: '' }
    }

    const filters = [
        {
            icon: 'apps',
            name: 'All'
        },
        {
            icon: 'desktop_mac',
            name: 'macOS'
        },
        {
            icon: 'phone_iphone',
            name: 'iOS'
        },
        {
            icon: 'watch',
            name: 'watchOS'
        },
        {
            icon: 'phone_android',
            name: 'Android'
        },
        {
            icon: 'web',
            name: 'Web'
        },
        {
            icon: 'extension',
            name: 'Extension'
        }
    ]

    const items = filters.map((filter) => (
        <a css={css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-decoration: none;
            padding: 10px;
            cursor: pointer;
            &:hover {
                background-color: rgb(239, 240, 241);
                border-radius: 10px;
            }
            &:active {
                transform: scale(0.9);
            }
        `} onClick={() => {
            props.onClick(filter)
        }} className={selectedFilter.name === filter.name ? 'selected' : ''} 
            key={filter.name}
        >
            <span css={css`
                font-family: "Material Icons";
                display: block;
                margin-bottom: 4px;
                font-size: 26px;
                color: mix(#fff, #342ead, 60%);
                transition: 0.25s ease;
            `}>
                {filter.icon}
            </span>
            <span css={css`
                display: block;
                font-size: 13px;
                color: mix(#fff, #342ead, 70%);
                transition: 0.25s ease;
                font-family: 'Open Sans', sans-serif;
                font-weight: 500;
            `}>
                {filter.name}
            </span>
        </a>
    ))

    return (
        <div css={css`
            display: table;
            margin: 0 auto;
            height: 60px;
            a.selected {
                background-color: rgb(239, 240, 241);
                border-radius: 10px;
            }

            margin-bottom: 100px;
        `}>
            <div css={css`
                display: flex;
                flex-wrap: wrap;
                margin: 0 20px;

                a {
                    width: 60px;
                }

                background-color: #fff;
                box-shadow: 0 0 1px 0 rgba(52, 46, 173, 0.25), 0 15px 30px 0 rgba(52, 46, 173, 0.1);
                border-radius: 12px;
                overflow: hidden;
                padding: 10px;
            `}>
                {items}
            </div>
        </div>
    )
}